import type {
  DailyShiftSlotRepository,
  ExportResult,
} from './ports/DailyShiftSlotRepository';

export interface ExportShiftSlotsInput {
  year: number;
  month: number;
}

export interface ExportShiftSlotsOutput {
  success: boolean;
  csvData: string;
  filename: string;
  errors?: string[];
}

/**
 * シフト枠をCSVエクスポートするUseCase
 * @param repository DailyShiftSlotRepository リポジトリインスタンス
 * @param input ExportShiftSlotsInput エクスポート条件
 * @returns Promise<ExportShiftSlotsOutput> エクスポート結果
 */
export async function exportShiftSlots(
  repository: DailyShiftSlotRepository,
  input: ExportShiftSlotsInput
): Promise<ExportShiftSlotsOutput> {
  try {
    const result: ExportResult = await repository.exportCsv(
      input.year,
      input.month
    );
    return {
      success: result.success,
      csvData: result.csvData,
      filename: result.filename,
    };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'エクスポートに失敗しました';
    return {
      success: false,
      csvData: '',
      filename: '',
      errors: [errorMessage],
    };
  }
}
